'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral([''], ['']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 997;\n    opacity: ', ';\n    visibility: ', ';\n    backface-visibility: hidden;\n    transition: all 0.5s;\n    overflow-y: auto;\n'], ['\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 997;\n    opacity: ', ';\n    visibility: ', ';\n    backface-visibility: hidden;\n    transition: all 0.5s;\n    overflow-y: auto;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _overlay = require('../../../atoms/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _modal = require('../../../molecules/modal');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalToggle = _styledComponents2.default.div(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2, function (_ref) {
    var visible = _ref.visible;
    return visible ? 1 : 0;
}, function (_ref2) {
    var visible = _ref2.visible;
    return visible ? 'visible' : 'hidden';
});

var ActionModal = function (_React$Component) {
    _inherits(ActionModal, _React$Component);

    function ActionModal(props) {
        _classCallCheck(this, ActionModal);

        var _this = _possibleConstructorReturn(this, (ActionModal.__proto__ || Object.getPrototypeOf(ActionModal)).call(this, props));

        _this.toggle = function () {
            _this.setState({
                visible: !_this.state.visible
            });
        };

        _this.state = {
            visible: false
        };
        return _this;
    }

    _createClass(ActionModal, [{
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    ModalToggle,
                    { onClick: this.toggle },
                    this.props.toggle
                ),
                _react2.default.createElement(
                    Wrapper,
                    { visible: this.state.visible },
                    _react2.default.createElement(_overlay2.default, { visible: this.state.visible, clickEvent: this.toggle }),
                    _react2.default.createElement(_modal2.default, {
                        size: this.props.size,
                        visible: this.state.visible,
                        items: this.props.items,
                        closeEvent: this.toggle,
                        footerText: this.props.footerText,
                        actionButtons: this.props.actionButtons })
                )
            );
        }
    }]);

    return ActionModal;
}(_react2.default.Component);

exports.default = ActionModal;